<div class="viewer">

  <button
    mat-icon-button
    class="close-btn"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <button
    *ngIf="images.length>1"
    mat-icon-button
    class="nav-btn prev-btn"
    (click)="prev()"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <img
    class="viewer-image"
    [src]="images[currentIndex]"
    alt="Gallery Image"
  >

  <button
    *ngIf="images.length>1"
    mat-icon-button
    class="nav-btn next-btn"
    (click)="next()"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>

  <div class="counter">
    {{currentIndex+1}} / {{images.length}}
  </div>

</div>